'use strict';

var BitmapImage = require('./bitmapimage');

var _require = require('./gif'),
    Gif = _require.Gif,
    GifError = _require.GifError;

var _require2 = require('./gifcodec'),
    GifCodec = _require2.GifCodec;

var _require3 = require('./gifframe'),
    GifFrame = _require3.GifFrame;

var GifUtil = require('./gifutil');

module.exports = {
  BitmapImage: BitmapImage,
  Gif: Gif,
  GifCodec: GifCodec,
  GifFrame: GifFrame,
  GifUtil: GifUtil,
  GifError: GifError
};